import { render, staticRenderFns } from "./VehicleBloc.vue?vue&type=template&id=106a6bc1&scoped=true"
import script from "./VehicleBloc.vue?vue&type=script&lang=ts"
export * from "./VehicleBloc.vue?vue&type=script&lang=ts"
import style0 from "./VehicleBloc.vue?vue&type=style&index=0&id=106a6bc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106a6bc1",
  null
  
)

export default component.exports